import './work.css'
import React from 'react'

function Work() {
  return (
    <div className='work' id='workid'>
          <div className="container">
            <div className="row">
                <div className="col-12">
                    <div class="section-title text-center">
                        <h5 class="sub-titleall">خطوات العمل</h5>
                        <h2 class="titleall">كيف نعمل ؟</h2>
                        </div>
                        <div className='how-it-work'>
                            <div className="row">
                                <div className='col-lg-3 col-md-6'>
                                    <div className='single-work text-center'>
                                        <div className='count-wrap pb-2'>
                                            <div className='count-inner'>
                                                <h2>01</h2>
                                            </div>
                                        </div>
                                        <div className='details-wrap'>
                                            <div className='details-inner'>
                                                <h4>الإنصات للعميل</h4>
                                                <p>الإنصات للعميل هو أحد أهم الجوانب في تقديم خدمة عملاء متميزة ومعالجة المشكلات بفعالية</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className='col-lg-3 col-md-6'>
                                    <div className='single-work text-center'>
                                        <div className='count-wrap pb-2'>
                                            <div className='count-inner'>
                                                <h2>02</h2>
                                            </div>
                                        </div>
                                        <div className='details-wrap'>
                                            <div className='details-inner'>
                                                <h4>الفحص المبدئي</h4>
                                                <p>الفحص المبدئي ليس مجرد خطوة روتينية، بل هو جزء أساسي من تقديم خدمة عملاء عالية الجودة وضمان أن كل مشكلة يتم التعامل معها بأكبر قدر من الدقة والكفاءة.</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className='col-lg-3 col-md-6'>
                                    <div className='single-work text-center'>
                                        <div className='count-wrap pb-2'>
                                            <div className='count-inner'>
                                                <h2>03</h2>
                                            </div>
                                        </div>
                                        <div className='details-wrap'>
                                            <div className='details-inner'>
                                                <h4>الإتفاق مع العميل</h4>
                                                <p>تقديم تقدير شامل للتكلفة الكلية , الإجابة على أسئلة العميل , الحصول على موافقة العميل</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className='col-lg-3 col-md-6'>
                                    <div className='single-work text-center'>
                                        <div className='count-wrap pb-2'>
                                            <div className='count-inner'>
                                                <h2>04</h2>
                                            </div>
                                        </div>
                                        <div className='details-wrap'>
                                            <div className='details-inner'>
                                                <h4>البدء بالإصلاح</h4>
                                                <p>بعد إتمام جميع الخطوات السابقة من الاستماع للعميل، الفحص المبدئي، وشرح الخطوات والتكاليف، يتم الشروع في إصلاح السيارة وفق أعلى معايير الجودة والسلامة والاحتراف.</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Work